import { useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { useEventStartFiltersConsts } from 'shared/hooks/useEventStartFilters';
import { BreadcrumbsData } from 'shared/types/cms';

interface BreadcrumbsMobileProps {
	breadcrumbs: Array<BreadcrumbsData>;
	navBack: () => void;
}

const BreadcrumbsMobile = ({ breadcrumbs, navBack }: BreadcrumbsMobileProps) => {
	const breadcrumbsRef = useRef<HTMLUListElement>(null);

	useEffect(() => {
		const breadcrumbs = breadcrumbsRef.current;
		if (breadcrumbs) {
			const wrapperWidth = breadcrumbs.parentElement?.offsetWidth as number;
			breadcrumbs.scrollTo(wrapperWidth, 0);
		}
	}, [breadcrumbs]);

	return (
		<>
			<span className="back" onClick={navBack}>
				{'<'}
			</span>
			<ul id="breadcrumb-scroll-wrapper" ref={breadcrumbsRef} className="breadcrumb-scroll-wrapper flex align__items--center">
				{breadcrumbs.map((item, index) => {
					return item.value ? (
						<NavLink
							key={`${item.label}-${index}`}
							to={{
								pathname: item.value,
								search: item.filter ? `?${useEventStartFiltersConsts.EVENT_START_FILTER_SEARCH_PARAM}=${item.filter}` : undefined,
								state: { ...item.state },
							}}
							className="breadcrumb-link height--full"
							rel={item.disableNoFollow ? undefined : 'nofollow'}
						>
							<li className="font--medium">{item.label}</li>
						</NavLink>
					) : (
						<p key={`${item.label}-${index}`} className="breadcrumb-link height--full">
							<li className="font--bold">{item.label?.replace('(live)', '').trim()}</li>
						</p>
					);
				})}
			</ul>
		</>
	);
};

export default BreadcrumbsMobile;
